const data = [
  {
    id: 1,
    icon: "⭕️",
    status: "open",
    title: "Subscription with credit card",
    content: "Subscribe to Google Cloud Platform to get access to Google Maps in house route of AirBnb.",
    created: "-",
    modified: "-",
    activity: [],
    currentComment: "",
  },
  {
    id: 2,
    icon: "⭕️",
    status: "open",
    title: "Attach photos to house preview",
    content:
      "When a user interacts with the map and presses a house location, the information and photos of the house should be displayed.",
    created: "-",
    modified: "-",
    activity: [],
    currentComment: "",
  },
  {
    id: 3,
    icon: "⭕️",
    status: "open",
    title: "Add an option to exit house preview",
    content: "Implement a button to exit the information modal about houses that are available for purchase.",
    created: "-",
    modified: "-",
    activity: [],
    currentComment: "",
  },
  {
    id: 4,
    icon: "⭕️",
    status: "open",
    title: "Add higher resolution images",
    content: "For the home and renting route add higher resolution example images of appartments.",
    created: "-",
    modified: "-",
    activity: [],
    currentComment: "",
  },
];

const statuses = [
  {
    status: "open",
    icon: "⭕️",
    color: "#EB5A46",
  },
  {
    status: "in progress",
    icon: "🔆️",
    color: "#00C2E0",
  },
  {
    status: "in review",
    icon: "📝",
    color: "#C377E0",
  },
  {
    status: "done",
    icon: "✅",
    color: "#3981DE",
  },
];

export { data, statuses };
